import { render } from "./App.vue?vue&type=template&id=0a5b7761"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0a5b7761&lang=scss"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__